// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"feff898d","280":"f200eaa7","489":"94911bd5","556":"94911bd5","617":"7984df1c","666":"465a59b2","838":"0f74833c"}[chunkId] + ".chunk.css";
};